'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Color = require('color');
var mergeClassNames = require('classnames');
var UUID = require('uuid');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Color__default = /*#__PURE__*/_interopDefaultLegacy(Color);
var mergeClassNames__default = /*#__PURE__*/_interopDefaultLegacy(mergeClassNames);
var UUID__namespace = /*#__PURE__*/_interopNamespace(UUID);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/**
 * The classNames of the colors builtin in Bluelib.
 */

var BuiltinColor;

(function (BuiltinColor) {
  BuiltinColor["RED"] = "color-red";
  BuiltinColor["ORANGE"] = "color-orange";
  BuiltinColor["YELLOW"] = "color-yellow";
  BuiltinColor["LIME"] = "color-lime";
  BuiltinColor["CYAN"] = "color-cyan";
  BuiltinColor["BLUE"] = "color-blue";
  BuiltinColor["MAGENTA"] = "color-magenta";
})(BuiltinColor || (BuiltinColor = {}));
/**
 * Convert a {@link Color} to an object containing the `--bluelib-${name}-r`, `--bluelib-${name}-g` and `--bluelib-${name}-b` properties, to be passed in
 * a `style` prop.
 *
 * Will return `None` if the `color` parameter is falsy.
 *
 * @param name - The property "name", to be filled in the template string described above.
 * @param color - The color to convert.
 */


function colorToBluelibStyle(name, color) {
  var colorObj = Color__default["default"](color);

  if (!color) {
    return {};
  }

  var result = {};
  result["--bluelib-".concat(name, "-r")] = colorObj.red();
  result["--bluelib-".concat(name, "-g")] = colorObj.green();
  result["--bluelib-".concat(name, "-b")] = colorObj.blue();
  return result;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$5 = "@import \"../normalize/normalize.css\";\n.skeleton-module_bluelib__1mI1R {\n  --bluelib-background-r: 255;\n  --bluelib-background-g: 255;\n  --bluelib-background-b: 255;\n  --bluelib-foreground-r: 24;\n  --bluelib-foreground-g: 24;\n  --bluelib-foreground-b: 24;\n  --bluelib-accent-r: 24;\n  --bluelib-accent-g: 24;\n  --bluelib-accent-b: 24;\n  --bluelib-link-r: 0;\n  --bluelib-link-g: 147;\n  --bluelib-link-b: 147;\n  --bluelib-broken-r: 245;\n  --bluelib-broken-g: 111;\n  --bluelib-broken-b: 0;\n  --bluelib-visited-r: 9;\n  --bluelib-visited-g: 101;\n  --bluelib-visited-b: 156;\n  --bluelib-download-r: 0;\n  --bluelib-download-g: 164;\n  --bluelib-download-b: 106;\n  --bluelib-red-r: 200;\n  --bluelib-red-g: 0;\n  --bluelib-red-b: 0;\n  --bluelib-orange-r: 200;\n  --bluelib-orange-g: 165;\n  --bluelib-orange-b: 0;\n  --bluelib-yellow-r: 200;\n  --bluelib-yellow-g: 200;\n  --bluelib-yellow-b: 0;\n  --bluelib-lime-r: 0;\n  --bluelib-lime-g: 200;\n  --bluelib-lime-b: 0;\n  --bluelib-cyan-r: 0;\n  --bluelib-cyan-g: 200;\n  --bluelib-cyan-b: 200;\n  --bluelib-blue-r: 0;\n  --bluelib-blue-g: 0;\n  --bluelib-blue-b: 200;\n  --bluelib-magenta-r: 200;\n  --bluelib-magenta-g: 0;\n  --bluelib-magenta-b: 200;\n  --bluelib-gray-r: 128;\n  --bluelib-gray-g: 128;\n  --bluelib-gray-b: 128;\n  --bluelib-polarity: -1;\n  --bluelib-title-family: sans-serif;\n  --bluelib-title-weight: bold;\n  --bluelib-text-family: sans-serif;\n  --bluelib-text-weight: normal;\n  --bluelib-code-family: monospace;\n  --bluelib-code-weight: normal;\n  background-color: rgb(var(--bluelib-background-r), var(--bluelib-background-g), var(--bluelib-background-b));\n  width: 100%;\n  height: 100%;\n  --bluelib-color-r: var(--bluelib-foreground-r);\n  --bluelib-color-g: var(--bluelib-foreground-g);\n  --bluelib-color-b: var(--bluelib-foreground-b);\n  font-family: var(--bluelib-text-family);\n  font-weight: var(--bluelib-text-weight);\n}\n.skeleton-module_bluelib__1mI1R,\n.skeleton-module_bluelib__1mI1R *,\n.skeleton-module_bluelib__1mI1R .skeleton-module_all__sS7LA {\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 1);\n  scrollbar-color: rgb(var(--bluelib-foreground-r), var(--bluelib-foreground-g), var(--bluelib-foreground-b)) rgb(var(--bluelib-background-r), var(--bluelib-background-g), var(--bluelib-background-b));\n}\n.skeleton-module_bluelib__1mI1R,\n.skeleton-module_bluelib__1mI1R *,\n.skeleton-module_bluelib__1mI1R .skeleton-module_all__sS7LA,\n.skeleton-module_bluelib__1mI1R::before,\n.skeleton-module_bluelib__1mI1R *::before,\n.skeleton-module_bluelib__1mI1R .skeleton-module_all__sS7LA::before,\n.skeleton-module_bluelib__1mI1R::after,\n.skeleton-module_bluelib__1mI1R *::after,\n.skeleton-module_bluelib__1mI1R .skeleton-module_all__sS7LA::after {\n  box-sizing: border-box;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_page-footer__FTbnk {\n  margin-top: 1em;\n  text-align: center;\n  font-size: x-small;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_layout__RoPSa {\n  display: grid;\n  justify-content: stretch;\n  align-items: stretch;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_layout-fill__f-Zjd {\n  padding: 4px;\n  grid-template-areas: \"single\";\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_layout-fill-single__ZaR7K {\n  grid-area: single;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol__IK2X1 {\n  padding: 4px;\n  grid-column-gap: 8px;\n}\n@media screen and (min-width: 1281px) {\n  .skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol__IK2X1 {\n    grid-template-areas: \"left center right\";\n    grid-template-columns: 1fr auto 1fr;\n    grid-template-rows: 1fr;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol__IK2X1 {\n    grid-template-areas: \"center center\" \"left right\";\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto auto;\n    max-width: 1024px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol-left__eL2A9 {\n  grid-area: left;\n}\n@media screen and (min-width: 1281px) {\n  .skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol-left__eL2A9 {\n    width: 128px;\n    justify-self: end;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol-left__eL2A9 {\n    justify-self: stretch;\n  }\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol-center__heiqH {\n  grid-area: center;\n}\n@media screen and (min-width: 1281px) {\n  .skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol-center__heiqH {\n    width: 1024px;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol-center__heiqH {\n    max-width: 1024px;\n  }\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol-right__C2UFo {\n  grid-area: right;\n}\n@media screen and (min-width: 1281px) {\n  .skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol-right__C2UFo {\n    width: 128px;\n    justify-self: start;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .skeleton-module_bluelib__1mI1R .skeleton-module_layout-threecol-right__C2UFo {\n    justify-self: stretch;\n  }\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_panel__k1hui {\n  margin: 8px 0;\n  padding: 8px;\n  border-radius: 4px;\n  width: 100%;\n  min-width: 312px;\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.03);\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.125);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_panel__k1hui > *:first-child,\n.skeleton-module_bluelib__1mI1R .skeleton-module_panel__k1hui .skeleton-module_all__sS7LA:first-child {\n  margin-top: 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_panel__k1hui > *:last-child,\n.skeleton-module_bluelib__1mI1R .skeleton-module_panel__k1hui .skeleton-module_all__sS7LA:last-child {\n  margin-bottom: 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_panel-box__lHywq {\n  border-width: 2px;\n  border-style: solid;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_panel-dialog__bb9qA {\n  border-width: 0 0 0 2px;\n  border-style: solid;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_panel-parenthesis__jHpZo {\n  border-width: 0;\n  font-size: smaller;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_chapter__E0zB3 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: stretch;\n  align-items: stretch;\n  margin: 8px 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_chapter__E0zB3 > *,\n.skeleton-module_bluelib__1mI1R .skeleton-module_chapter__E0zB3 .skeleton-module_all__sS7LA {\n  flex-grow: 1;\n  flex-shrink: 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_chapter__E0zB3 > .skeleton-module_heading__pROZK {\n  flex-basis: 100%;\n  margin-top: 0.2rem;\n  margin-bottom: 0.2rem;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_chapter__E0zB3 > .skeleton-module_heading__pROZK:first-child {\n  margin-top: 1rem;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_chapter__E0zB3 > .skeleton-module_heading__pROZK:last-child {\n  margin-bottom: 1rem;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_chapter__E0zB3 > .skeleton-module_panel__k1hui {\n  margin: 0;\n  flex-basis: 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_chapter-forcewrap__qAo1q {\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 100%;\n  position: relative;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_separator__v0o6Q {\n  border-width: 1px;\n  border-style: solid;\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.505);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_separator-light__IjYQS {\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.125);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_separator-heavy__fTUzQ {\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_image__kpKg- {\n  display: block;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  object-fit: contain;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_image-limit-half__S0M-3 {\n  max-height: max(28.2vw, 50vh);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_image-limit-quarter__ehNGs {\n  max-height: max(14.1vw, 25vh);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_table__iebd- {\n  display: table;\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.03);\n  border-width: 2px 2px 2px 2px;\n  border-style: solid;\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.125);\n  border-radius: 0 0 4px 4px;\n  border-collapse: collapse;\n  padding: 8px;\n  margin: 8px 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_table-caption__BrTZv {\n  display: table-caption;\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.03);\n  padding: 4px;\n  font-style: italic;\n  font-size: small;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_table-caption-top__DgwWA {\n  caption-side: top;\n  border-width: 2px 2px 0 2px;\n  border-style: solid;\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.125);\n  border-radius: 4px 4px 0 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_table-caption-bottom__EemnS {\n  caption-side: bottom;\n  border-width: 0 2px 2px 2px;\n  border-style: solid;\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.125);\n  border-radius: 0 0 4px 4px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_table-header__z8hV1 {\n  display: table-header-group;\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.03);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_table-body__VmXq- {\n  display: table-row-group;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_table-footer__CA-xP {\n  display: table-footer-group;\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.03);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_table-row__jrRmr {\n  display: table-row;\n  border: 1px solid rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.125);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_table-data__7uGM3,\n.skeleton-module_bluelib__1mI1R .skeleton-module_table-head__xOtus {\n  display: table-cell;\n  border: 1px solid rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.125);\n  padding: 8px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_table-head__xOtus {\n  color: rgb(var(--bluelib-accent-r), var(--bluelib-accent-g), var(--bluelib-accent-b));\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_table-mark__KHUvB {\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.22);\n  color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 50)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 50)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 50)), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_list-item__lMO4q {\n  margin: 0.35rem 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_list-item__lMO4q::marker {\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.505);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_list-description-term__S4BjW {\n  margin-top: 0.7rem;\n  margin-bottom: 0.35rem;\n  font-size: larger;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_list-description-details__SIUqP {\n  margin-top: 0.35rem;\n  margin-bottom: 0.7rem;\n  margin-left: 16px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_status-disabled__z--W6 {\n  opacity: 50%;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_status-disabled__z--W6,\n.skeleton-module_bluelib__1mI1R .skeleton-module_status-disabled__z--W6 *,\n.skeleton-module_bluelib__1mI1R .skeleton-module_status-disabled__z--W6 .skeleton-module_all__sS7LA {\n  cursor: not-allowed !important;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0 {\n  font: inherit;\n  width: 100%;\n  border-style: solid;\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.315);\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 1);\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.03);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0.skeleton-module_status-disabled__z--W6 {\n  border-style: dashed;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0::placeholder {\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.41);\n  opacity: 1;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0:hover {\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.6);\n  color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 20)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 20)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 20)), 1);\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.125);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0:hover::placeholder {\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.7);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0:focus {\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 1);\n  color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 50)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 50)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 50)), 1);\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.22);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0:focus::placeholder {\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.7);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0.skeleton-module_status-disabled__z--W6:hover,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0.skeleton-module_status-disabled__z--W6:focus {\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.315);\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 1);\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.03);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0.skeleton-module_status-disabled__z--W6:hover::placeholder,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0.skeleton-module_status-disabled__z--W6:focus::placeholder {\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.41);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0:optional,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0:optional::placeholder {\n  font-style: italic;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input__QXDK0:focus-visible {\n  outline: none;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-field__4PIgb {\n  cursor: text;\n  border-width: 0 0 2px 0;\n  border-radius: 4px 4px 0 0;\n  padding: 6px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-area__oruU- {\n  cursor: text;\n  border-width: 0 0 0 2px;\n  border-radius: 0 4px 4px 0;\n  padding: 6px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-select__A6V49 {\n  cursor: context-menu;\n  border-width: 0 0 2px 0;\n  border-radius: 4px 4px 0 0;\n}\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  .skeleton-module_bluelib__1mI1R .skeleton-module_input-select__A6V49 .skeleton-module_input-option__3Qd22,\n  .skeleton-module_bluelib__1mI1R .skeleton-module_input-select__A6V49 .skeleton-module_input-optgroup__Pg9rB {\n    background-color: rgb(var(--bluelib-background-r), var(--bluelib-background-g), var(--bluelib-background-b));\n  }\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-multiselect__WzpLG {\n  cursor: vertical-text;\n  border-width: 0 0 0 2px;\n  border-radius: 0 4px 4px 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-select__A6V49,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-multiselect__WzpLG {\n  padding: 6px 4px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-select__A6V49 .skeleton-module_input-option__3Qd22,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-multiselect__WzpLG .skeleton-module_input-option__3Qd22 {\n  font-weight: normal;\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 1);\n  padding: 4px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-select__A6V49 .skeleton-module_input-optgroup__Pg9rB,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-multiselect__WzpLG .skeleton-module_input-optgroup__Pg9rB {\n  font-weight: bold;\n  color: rgb(var(--bluelib-accent-r), var(--bluelib-accent-g), var(--bluelib-accent-b));\n  padding: 4px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-select__A6V49 .skeleton-module_input-optgroup__Pg9rB .skeleton-module_input-option__3Qd22,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-multiselect__WzpLG .skeleton-module_input-optgroup__Pg9rB .skeleton-module_input-option__3Qd22 {\n  padding: 4px 20px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-select__A6V49 .skeleton-module_input-optgroup__Pg9rB .skeleton-module_input-option__3Qd22::before,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-multiselect__WzpLG .skeleton-module_input-optgroup__Pg9rB .skeleton-module_input-option__3Qd22::before {\n  content: \"\";\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-button__v544E {\n  cursor: pointer;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 16px;\n  border-radius: 4px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-button__v544E:active {\n  border-color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 20)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 20)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 20)), 1);\n  color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 50)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 50)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 50)), 1);\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.315);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-button__v544E .skeleton-module_status-disabled__z--W6:active {\n  border-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.315);\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 1);\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.03);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-checkbox__52JYT,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-radio__Q9Tga {\n  appearance: none;\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  border-width: 2px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-checkbox__52JYT::before,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-radio__Q9Tga::before {\n  display: block;\n  content: \"\";\n  width: 14px;\n  height: 14px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-checkbox__52JYT:checked::before,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-radio__Q9Tga:checked::before {\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.9);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-checkbox__52JYT:hover:checked::before,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-radio__Q9Tga:hover:checked::before {\n  background-color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 10)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 10)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 10)), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-checkbox__52JYT:focus:checked::before,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-radio__Q9Tga:focus:checked::before {\n  background-color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 30)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 30)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 30)), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-checkbox__52JYT:active:checked::before,\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-radio__Q9Tga:active:checked::before {\n  background-color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 30)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 30)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 30)), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-checkbox__52JYT {\n  border-radius: 4px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-checkbox__52JYT::before {\n  border-radius: 2px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-radio__Q9Tga {\n  border-radius: 100%;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_input-radio__Q9Tga::before {\n  border-radius: 100%;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_form__7Z9Cw {\n  display: grid;\n  align-items: center;\n  row-gap: 4px;\n  column-gap: 8px;\n  grid-template-columns: minmax(auto, 1fr) 5fr;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_form__7Z9Cw .skeleton-module_form-label__w5CmL {\n  grid-column: 1;\n  justify-self: end;\n  text-align: right;\n  --bluelib-color-r: var(--bluelib-accent-r);\n  --bluelib-color-g: var(--bluelib-accent-g);\n  --bluelib-color-b: var(--bluelib-accent-b);\n  font-weight: 500;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_form__7Z9Cw .skeleton-module_form-input__5nr4i {\n  grid-column: 2;\n  justify-self: stretch;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_form__7Z9Cw .skeleton-module_form-group__3EcRB {\n  grid-column: 2;\n  display: flex;\n  gap: 8px 16px;\n  justify-content: space-evenly;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.03);\n  padding: 6px;\n  border-radius: 4px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_form__7Z9Cw .skeleton-module_form-group__3EcRB .skeleton-module_form-group-label__F79nJ {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_form__7Z9Cw .skeleton-module_form-group__3EcRB .skeleton-module_form-group-row__C9nz2 {\n  flex-basis: 100%;\n  justify-content: start;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_form__7Z9Cw .skeleton-module_form-row__QLuDM {\n  grid-column-start: 1;\n  grid-column-end: 3;\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_form__7Z9Cw .skeleton-module_form-row__QLuDM .skeleton-module_panel__k1hui {\n  margin: 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_form__7Z9Cw .skeleton-module_form-row__QLuDM:first-child {\n  margin-top: 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_form__7Z9Cw .skeleton-module_form-row__QLuDM:last-child {\n  margin-bottom: 0;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_heading__pROZK {\n  text-align: center;\n  --bluelib-color-r: var(--bluelib-accent-r);\n  --bluelib-color-g: var(--bluelib-accent-g);\n  --bluelib-color-b: var(--bluelib-accent-b);\n  font-family: var(--bluelib-title-family);\n  font-weight: var(--bluelib-title-weight);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor__oEUHJ {\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor__oEUHJ:focus-visible {\n  text-decoration-thickness: 2px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor__oEUHJ:hover,\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor__oEUHJ:focus {\n  color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 30)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 30)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 30)), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor__oEUHJ:active {\n  color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 60)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 60)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 60)), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor-broken__E-ZIG {\n  cursor: not-allowed;\n  --bluelib-color-r: var(--bluelib-broken-r);\n  --bluelib-color-g: var(--bluelib-broken-g);\n  --bluelib-color-b: var(--bluelib-broken-b);\n  text-decoration-style: dashed;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor-broken__E-ZIG:hover,\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor-broken__E-ZIG:focus,\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor-broken__E-ZIG:active {\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor-link__eQCKT {\n  cursor: pointer;\n  --bluelib-color-r: var(--bluelib-link-r);\n  --bluelib-color-g: var(--bluelib-link-g);\n  --bluelib-color-b: var(--bluelib-link-b);\n  text-decoration-style: solid;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor-link__eQCKT:visited {\n  --bluelib-color-r: var(--bluelib-visited-r);\n  --bluelib-color-g: var(--bluelib-visited-g);\n  --bluelib-color-b: var(--bluelib-visited-b);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_anchor-download__7ns4V {\n  cursor: pointer;\n  --bluelib-color-r: var(--bluelib-download-r);\n  --bluelib-color-g: var(--bluelib-download-g);\n  --bluelib-color-b: var(--bluelib-download-b);\n  text-decoration-style: solid;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_details__8waWL {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_details__8waWL > .skeleton-module_details-summary__bZJ8K {\n  cursor: pointer;\n  font-size: larger;\n  user-select: none;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_details__8waWL > .skeleton-module_details-summary__bZJ8K:hover {\n  color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 20)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 20)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 20)), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_details__8waWL > .skeleton-module_details-summary__bZJ8K:focus-visible {\n  color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 30)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 30)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 30)), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_details__8waWL > .skeleton-module_details-summary__bZJ8K:active {\n  color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 90)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 90)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 90)), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_details__8waWL > .skeleton-module_details-content__e6hAI {\n  margin-top: 0.5rem;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_details__8waWL > .skeleton-module_details__8waWL {\n  margin-left: 16px;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_ruby-parenthesis__xjU9U {\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.125);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_ruby-text__ej6bL {\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.6);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_todo__UbU-s {\n  background-color: #292F33;\n  --bluelib-color-r: 255;\n  --bluelib-color-g: 204;\n  --bluelib-color-b: 77;\n  border-color: #FFCC4D;\n}\n.skeleton-module_bluelib__1mI1R abbr,\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-abbr__98os7 {\n  cursor: help;\n  text-decoration: underline 1px dotted currentColor;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-b__IuQ8v {\n  font-weight: 500;\n  color: rgb(var(--bluelib-accent-r), var(--bluelib-accent-g), var(--bluelib-accent-b));\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-cite__WFQIt {\n  font-variant: small-caps;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-code__vEaPS {\n  font-family: var(--bluelib-code-family);\n  font-weight: var(--bluelib-code-weight);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-dfn__Tur47 {\n  text-decoration: underline 1px solid currentColor;\n  font-style: italic;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-em__yJvw- {\n  color: rgb(var(--bluelib-accent-r), var(--bluelib-accent-g), var(--bluelib-accent-b));\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-i__bdUt7 {\n  font-style: italic;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-mark__5Aupw {\n  background-color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.22);\n  color: rgba(calc(var(--bluelib-color-r) + (var(--bluelib-polarity) * 50)), calc(var(--bluelib-color-g) + (var(--bluelib-polarity) * 50)), calc(var(--bluelib-color-b) + (var(--bluelib-polarity) * 50)), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-q__re1f6 {\n  font-style: oblique;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-q__re1f6:before,\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-q__re1f6:after {\n  color: rgba(var(--bluelib-color-r), var(--bluelib-color-g), var(--bluelib-color-b), 0.505);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-samp__wEp-U {\n  background-color: rgba(calc(255 * (((var(--bluelib-polarity) / 2) * -1) + 0.5)), calc(255 * (((var(--bluelib-polarity) / 2) * -1) + 0.5)), calc(255 * (((var(--bluelib-polarity) / 2) * -1) + 0.5)), 1);\n  color: rgba(calc(255 * ((var(--bluelib-polarity) / 2) + 0.5)), calc(255 * ((var(--bluelib-polarity) / 2) + 0.5)), calc(255 * ((var(--bluelib-polarity) / 2) + 0.5)), 1);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-strong__9YV6- {\n  font-weight: 800;\n  color: rgb(var(--bluelib-accent-r), var(--bluelib-accent-g), var(--bluelib-accent-b));\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_semantic-var__vkHIO {\n  font-style: normal;\n  color: rgb(var(--bluelib-accent-r), var(--bluelib-accent-g), var(--bluelib-accent-b));\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_color-red__ngYKX {\n  --bluelib-color-r: var(--bluelib-red-r);\n  --bluelib-color-g: var(--bluelib-red-g);\n  --bluelib-color-b: var(--bluelib-red-b);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_color-orange__jTZw8 {\n  --bluelib-color-r: var(--bluelib-orange-r);\n  --bluelib-color-g: var(--bluelib-orange-g);\n  --bluelib-color-b: var(--bluelib-orange-b);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_color-yellow__ZBe8e {\n  --bluelib-color-r: var(--bluelib-yellow-r);\n  --bluelib-color-g: var(--bluelib-yellow-g);\n  --bluelib-color-b: var(--bluelib-yellow-b);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_color-lime__w1SLW {\n  --bluelib-color-r: var(--bluelib-lime-r);\n  --bluelib-color-g: var(--bluelib-lime-g);\n  --bluelib-color-b: var(--bluelib-lime-b);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_color-cyan__ONUPU {\n  --bluelib-color-r: var(--bluelib-cyan-r);\n  --bluelib-color-g: var(--bluelib-cyan-g);\n  --bluelib-color-b: var(--bluelib-cyan-b);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_color-blue__u8Lw- {\n  --bluelib-color-r: var(--bluelib-blue-r);\n  --bluelib-color-g: var(--bluelib-blue-g);\n  --bluelib-color-b: var(--bluelib-blue-b);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_color-magenta__2iv-I {\n  --bluelib-color-r: var(--bluelib-magenta-r);\n  --bluelib-color-g: var(--bluelib-magenta-g);\n  --bluelib-color-b: var(--bluelib-magenta-b);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_color-gray__R4W7H {\n  --bluelib-color-r: var(--bluelib-gray-r);\n  --bluelib-color-g: var(--bluelib-gray-g);\n  --bluelib-color-b: var(--bluelib-gray-b);\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_special-remove__Joiv- {\n  display: none !important;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_special-hide__Bw7Dk {\n  visibility: hidden !important;\n}\n.skeleton-module_bluelib__1mI1R .skeleton-module_special-block-center__TBAnw {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}";
var Skeleton = {"bluelib":"skeleton-module_bluelib__1mI1R","all":"skeleton-module_all__sS7LA","page-footer":"skeleton-module_page-footer__FTbnk","layout":"skeleton-module_layout__RoPSa","layout-fill":"skeleton-module_layout-fill__f-Zjd","layout-fill-single":"skeleton-module_layout-fill-single__ZaR7K","layout-threecol":"skeleton-module_layout-threecol__IK2X1","layout-threecol-left":"skeleton-module_layout-threecol-left__eL2A9","layout-threecol-center":"skeleton-module_layout-threecol-center__heiqH","layout-threecol-right":"skeleton-module_layout-threecol-right__C2UFo","panel":"skeleton-module_panel__k1hui","panel-box":"skeleton-module_panel-box__lHywq","panel-dialog":"skeleton-module_panel-dialog__bb9qA","panel-parenthesis":"skeleton-module_panel-parenthesis__jHpZo","chapter":"skeleton-module_chapter__E0zB3","heading":"skeleton-module_heading__pROZK","chapter-forcewrap":"skeleton-module_chapter-forcewrap__qAo1q","separator":"skeleton-module_separator__v0o6Q","separator-light":"skeleton-module_separator-light__IjYQS","separator-heavy":"skeleton-module_separator-heavy__fTUzQ","image":"skeleton-module_image__kpKg-","image-limit-half":"skeleton-module_image-limit-half__S0M-3","image-limit-quarter":"skeleton-module_image-limit-quarter__ehNGs","table":"skeleton-module_table__iebd-","table-caption":"skeleton-module_table-caption__BrTZv","table-caption-top":"skeleton-module_table-caption-top__DgwWA","table-caption-bottom":"skeleton-module_table-caption-bottom__EemnS","table-header":"skeleton-module_table-header__z8hV1","table-body":"skeleton-module_table-body__VmXq-","table-footer":"skeleton-module_table-footer__CA-xP","table-row":"skeleton-module_table-row__jrRmr","table-data":"skeleton-module_table-data__7uGM3","table-head":"skeleton-module_table-head__xOtus","table-mark":"skeleton-module_table-mark__KHUvB","list-item":"skeleton-module_list-item__lMO4q","list-description-term":"skeleton-module_list-description-term__S4BjW","list-description-details":"skeleton-module_list-description-details__SIUqP","status-disabled":"skeleton-module_status-disabled__z--W6","input":"skeleton-module_input__QXDK0","input-field":"skeleton-module_input-field__4PIgb","input-area":"skeleton-module_input-area__oruU-","input-select":"skeleton-module_input-select__A6V49","input-option":"skeleton-module_input-option__3Qd22","input-optgroup":"skeleton-module_input-optgroup__Pg9rB","input-multiselect":"skeleton-module_input-multiselect__WzpLG","input-button":"skeleton-module_input-button__v544E","input-checkbox":"skeleton-module_input-checkbox__52JYT","input-radio":"skeleton-module_input-radio__Q9Tga","form":"skeleton-module_form__7Z9Cw","form-label":"skeleton-module_form-label__w5CmL","form-input":"skeleton-module_form-input__5nr4i","form-group":"skeleton-module_form-group__3EcRB","form-group-label":"skeleton-module_form-group-label__F79nJ","form-group-row":"skeleton-module_form-group-row__C9nz2","form-row":"skeleton-module_form-row__QLuDM","anchor":"skeleton-module_anchor__oEUHJ","anchor-broken":"skeleton-module_anchor-broken__E-ZIG","anchor-link":"skeleton-module_anchor-link__eQCKT","anchor-download":"skeleton-module_anchor-download__7ns4V","details":"skeleton-module_details__8waWL","details-summary":"skeleton-module_details-summary__bZJ8K","details-content":"skeleton-module_details-content__e6hAI","ruby-parenthesis":"skeleton-module_ruby-parenthesis__xjU9U","ruby-text":"skeleton-module_ruby-text__ej6bL","todo":"skeleton-module_todo__UbU-s","semantic-abbr":"skeleton-module_semantic-abbr__98os7","semantic-b":"skeleton-module_semantic-b__IuQ8v","semantic-cite":"skeleton-module_semantic-cite__WFQIt","semantic-code":"skeleton-module_semantic-code__vEaPS","semantic-dfn":"skeleton-module_semantic-dfn__Tur47","semantic-em":"skeleton-module_semantic-em__yJvw-","semantic-i":"skeleton-module_semantic-i__bdUt7","semantic-mark":"skeleton-module_semantic-mark__5Aupw","semantic-q":"skeleton-module_semantic-q__re1f6","semantic-samp":"skeleton-module_semantic-samp__wEp-U","semantic-strong":"skeleton-module_semantic-strong__9YV6-","semantic-var":"skeleton-module_semantic-var__vkHIO","color-red":"skeleton-module_color-red__ngYKX","color-orange":"skeleton-module_color-orange__jTZw8","color-yellow":"skeleton-module_color-yellow__ZBe8e","color-lime":"skeleton-module_color-lime__w1SLW","color-cyan":"skeleton-module_color-cyan__ONUPU","color-blue":"skeleton-module_color-blue__u8Lw-","color-magenta":"skeleton-module_color-magenta__2iv-I","color-gray":"skeleton-module_color-gray__R4W7H","special-remove":"skeleton-module_special-remove__Joiv-","special-hide":"skeleton-module_special-hide__Bw7Dk","special-block-center":"skeleton-module_special-block-center__TBAnw"};
styleInject(css_248z$5);

/**
 * Get the Bluelib module classNames given a string of root classNames.
 *
 * @param inputClassName - The root classNames.
 */

function rootToModule(inputClassName) {
  var flattenedClassName = mergeClassNames__default["default"](inputClassName);
  var flattenedClassNames = flattenedClassName.split(" ");
  var skeletonClassNames = flattenedClassNames.map(function (value) {
    return Skeleton[value];
  });
  var skeletonClassName = mergeClassNames__default["default"](skeletonClassNames);
  return skeletonClassName;
}

var BaseElement = function BaseElement(_a) {
  var _b = _a.kind,
      kind = _b === void 0 ? "div" : _b,
      bluelibClassNames = _a.bluelibClassNames,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      builtinColor = _a.builtinColor,
      customColor = _a.customColor,
      childRef = _a.childRef,
      props = __rest(_a, ["kind", "bluelibClassNames", "disabled", "builtinColor", "customColor", "childRef"]); // Set the Bluelib color


  if (customColor) {
    props.style = __assign(__assign({}, props.style), colorToBluelibStyle("color", customColor));
  } // Possibly disable the element


  bluelibClassNames = mergeClassNames__default["default"](bluelibClassNames, disabled ? "status-disabled" : "", (builtinColor === null || builtinColor === void 0 ? void 0 : builtinColor.length) ? "color-".concat(builtinColor) : ""); // @ts-ignore

  props.disabled = disabled; // Map regular class names to module class names

  bluelibClassNames = rootToModule(bluelibClassNames);
  props.className = mergeClassNames__default["default"](props.className, bluelibClassNames); // Set the ref on the child element

  if (childRef) {
    props.ref = childRef;
  }

  return /*#__PURE__*/React__namespace.createElement(kind, props);
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=React__default["default"],g=60103;reactJsxRuntime_production_min.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");reactJsxRuntime_production_min.Fragment=h("react.fragment");}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;

var reactJsxRuntime_development = {};

/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

var React = React__default["default"];
var _assign = objectAssign;

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
exports.Fragment = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  exports.Fragment = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case exports.Fragment:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown;
var specialPropRefWarningShown;
var didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function warnIfStringRefCannotBeAutoConverted(config, self) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}

function defineKeyPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingKey = function () {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingKey.isReactWarning = true;
    Object.defineProperty(props, 'key', {
      get: warnAboutAccessingKey,
      configurable: true
    });
  }
}

function defineRefPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingRef = function () {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingRef.isReactWarning = true;
    Object.defineProperty(props, 'ref', {
      get: warnAboutAccessingRef,
      configurable: true
    });
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */

function jsxDEV(type, config, maybeKey, source, self) {
  {
    var propName; // Reserved names are extracted

    var props = {};
    var key = null;
    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
    // but as an intermediary step, we will use jsxDEV for everything except
    // <div {...props} key="Hi" />, because we aren't currently able to tell if
    // key is explicitly declared to be undefined or not.

    if (maybeKey !== undefined) {
      key = '' + maybeKey;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    if (hasValidRef(config)) {
      ref = config.ref;
      warnIfStringRefCannotBeAutoConverted(config, self);
    } // Remaining properties are added to a new props object


    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    } // Resolve default props


    if (type && type.defaultProps) {
      var defaultProps = type.defaultProps;

      for (propName in defaultProps) {
        if (props[propName] === undefined) {
          props[propName] = defaultProps[propName];
        }
      }
    }

    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }

    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
}

function getDeclarationErrorAddendum() {
  {
    if (ReactCurrentOwner$1.current) {
      var name = getComponentName(ReactCurrentOwner$1.current.type);

      if (name) {
        return '\n\nCheck the render method of `' + name + '`.';
      }
    }

    return '';
  }
}

function getSourceInfoErrorAddendum(source) {
  {
    if (source !== undefined) {
      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
      var lineNumber = source.lineNumber;
      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
    }

    return '';
  }
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  {
    var info = getDeclarationErrorAddendum();

    if (!info) {
      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

      if (parentName) {
        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
      }
    }

    return info;
  }
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  {
    if (!element._store || element._store.validated || element.key != null) {
      return;
    }

    element._store.validated = true;
    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
      return;
    }

    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
    // property, it may be the creator of the child that's responsible for
    // assigning it a key.

    var childOwner = '';

    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
      // Give the component that originally created this child.
      childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
    }

    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  {
    if (typeof node !== 'object') {
      return;
    }

    if (Array.isArray(node)) {
      for (var i = 0; i < node.length; i++) {
        var child = node[i];

        if (isValidElement(child)) {
          validateExplicitKey(child, parentType);
        }
      }
    } else if (isValidElement(node)) {
      // This element was passed in a valid location.
      if (node._store) {
        node._store.validated = true;
      }
    } else if (node) {
      var iteratorFn = getIteratorFn(node);

      if (typeof iteratorFn === 'function') {
        // Entry iterators used to provide implicit keys,
        // but now we print a separate warning for them later.
        if (iteratorFn !== node.entries) {
          var iterator = iteratorFn.call(node);
          var step;

          while (!(step = iterator.next()).done) {
            if (isValidElement(step.value)) {
              validateExplicitKey(step.value, parentType);
            }
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentName(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentName(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}

function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
  {
    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.

    if (!validType) {
      var info = '';

      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
      }

      var sourceInfo = getSourceInfoErrorAddendum(source);

      if (sourceInfo) {
        info += sourceInfo;
      } else {
        info += getDeclarationErrorAddendum();
      }

      var typeString;

      if (type === null) {
        typeString = 'null';
      } else if (Array.isArray(type)) {
        typeString = 'array';
      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
        typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
        info = ' Did you accidentally export a JSX literal instead of a component?';
      } else {
        typeString = typeof type;
      }

      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }

    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.

    if (element == null) {
      return element;
    } // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)


    if (validType) {
      var children = props.children;

      if (children !== undefined) {
        if (isStaticChildren) {
          if (Array.isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              validateChildKeys(children[i], type);
            }

            if (Object.freeze) {
              Object.freeze(children);
            }
          } else {
            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
          }
        } else {
          validateChildKeys(children, type);
        }
      }
    }

    if (type === exports.Fragment) {
      validateFragmentProps(element);
    } else {
      validatePropTypes(element);
    }

    return element;
  }
} // These two functions exist to still get child warnings in dev
// even with the prod transform. This means that jsxDEV is purely
// opt-in behavior for better messages but that we won't stop
// giving you warnings if you use production apis.

function jsxWithValidationStatic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, true);
  }
}
function jsxWithValidationDynamic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, false);
  }
}

var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
// for now we can ship identical prod functions

var jsxs =  jsxWithValidationStatic ;

exports.jsx = jsx;
exports.jsxs = jsxs;
  })();
}
}(reactJsxRuntime_development));

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = reactJsxRuntime_production_min;
} else {
  jsxRuntime.exports = reactJsxRuntime_development;
}

function RubyParenthesis(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "ruby-parenthesis");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "rp"
  }, props), void 0);
}

function RubyText(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "ruby-text");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "rt"
  }, props), void 0);
}

function RubyBlock(_a) {
  var text = _a.text,
      _b = _a.open,
      open = _b === void 0 ? "(" : _b,
      annotation = _a.annotation,
      _c = _a.close,
      close = _c === void 0 ? ")" : _c;
  return jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, {
    children: [text, jsxRuntime.exports.jsx(RubyParenthesis, {
      children: open
    }, void 0), jsxRuntime.exports.jsx(RubyText, {
      children: annotation
    }, void 0), jsxRuntime.exports.jsx(RubyParenthesis, {
      children: close
    }, void 0)]
  }, void 0);
}

function Ruby(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "ruby");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "ruby"
  }, props), void 0);
}
Ruby.Block = RubyBlock;
Ruby.Internals = {
  Parenthesis: RubyParenthesis,
  Block: RubyBlock
};

function ChapterForceWrap(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "chapter-forcewrap");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "div"
  }, props), void 0);
}

function Chapter(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "chapter");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "section"
  }, props), void 0);
}
Chapter.ForceWrap = ChapterForceWrap;

var DISPLAY_STYLE_CLASSES = {
  link: "anchor-link",
  download: "anchor-download",
  broken: "anchor-broken"
};
function Anchor(_a) {
  var displayStyle = _a.displayStyle,
      href = _a.href,
      props = __rest(_a, ["displayStyle", "href"]);

  if (!displayStyle) {
    if (href) {
      // noinspection HttpUrlsUsage
      if (href.startsWith("http://") || href.startsWith("https://") || href.startsWith("/") || !href.includes(":")) {
        displayStyle = "link";
      } else {
        displayStyle = "download";
      }
    } else {
      displayStyle = "broken";
    }
  }

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "anchor", DISPLAY_STYLE_CLASSES[displayStyle]);
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "a",
    href: href
  }, props), void 0);
}

var HEADING_KINDS_BY_LEVEL = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5",
  6: "h6"
};
function Heading(_a) {
  var level = _a.level,
      props = __rest(_a, ["level"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "heading");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: HEADING_KINDS_BY_LEVEL[level]
  }, props), void 0);
}

function DetailsSummary(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "details-summary");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "summary"
  }, props), void 0);
}

function DetailsContent(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "details-content");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "div"
  }, props), void 0);
}

function Details(_a) {
  var children = _a.children,
      disabled = _a.disabled,
      onClick = _a.onClick,
      props = __rest(_a, ["children", "disabled", "onClick"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "details");
  var onClickWrapper = React__namespace.useCallback(function (event) {
    if (disabled) {
      event.preventDefault();
    } else if (onClick) {
      onClick(event);
    }
  }, [disabled, onClick]);
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "details",
    onClick: onClickWrapper,
    disabled: disabled
  }, props, {
    children: children
  }), void 0);
}
Details.Summary = DetailsSummary;
Details.Content = DetailsContent;

function FormPair(_a) {
  var id = _a.id,
      label = _a.label,
      input = _a.input,
      validity = _a.validity,
      bluelibClassNames = _a.bluelibClassNames,
      customColor = _a.customColor;

  if (!id) {
    id = UUID__namespace.v4();
  }

  var validityClass = "";

  if (validity === null) {
    validityClass = "color-yellow";
  } else if (validity === true) {
    validityClass = "color-lime";
  } else if (validity === false) {
    validityClass = "color-red";
  }

  label = /*#__PURE__*/React__namespace.cloneElement(label, {
    htmlFor: id,
    bluelibClassNames: mergeClassNames__default["default"](bluelibClassNames, validityClass),
    customColor: customColor
  });
  input = /*#__PURE__*/React__namespace.cloneElement(input, {
    id: id,
    bluelibClassNames: mergeClassNames__default["default"](bluelibClassNames, validityClass),
    customColor: customColor
  });
  return jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, {
    children: [label, input]
  }, void 0);
}

function FormLabel(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "form-label");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "label"
  }, props), void 0);
}

function Area(_a) {
  var onChange = _a.onChange,
      onSimpleChange = _a.onSimpleChange,
      props = __rest(_a, ["onChange", "onSimpleChange"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "input", "input-area");
  var onChangeWrapped = React__namespace.useCallback(function (event) {
    if (onChange) onChange(event);
    if (onSimpleChange) onSimpleChange(event.target.value);
  }, [onChange, onSimpleChange]);
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "textarea",
    onChange: onChangeWrapped
  }, props), void 0);
}

function FormArea(_a) {
  var label = _a.label,
      validity = _a.validity,
      pairProps = _a.pairProps,
      labelProps = _a.labelProps,
      props = __rest(_a, ["label", "validity", "pairProps", "labelProps"]);

  return jsxRuntime.exports.jsx(FormPair, __assign({
    label: jsxRuntime.exports.jsx(FormLabel, __assign({}, labelProps, {
      children: label
    }), void 0),
    input: jsxRuntime.exports.jsx(Area, __assign({}, props), void 0),
    validity: validity
  }, pairProps), void 0);
}

function FormGroup(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "form-group");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "div"
  }, props), void 0);
}

function InputLabel(_a) {
  var props = __rest(_a, []);

  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "label"
  }, props), void 0);
}

function Checkbox(_a) {
  var onChange = _a.onChange,
      onSimpleChange = _a.onSimpleChange,
      props = __rest(_a, ["onChange", "onSimpleChange"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "input", "input-checkbox");
  var onChangeWrapped = React__namespace.useCallback(function (event) {
    if (onChange) onChange(event);
    if (onSimpleChange) onSimpleChange(event.target.value, event.target.checked);
  }, [onChange, onSimpleChange]);
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "input",
    type: "checkbox",
    onChange: onChangeWrapped
  }, props), void 0);
}

function LabelledCheckbox(_a) {
  var label = _a.label,
      _b = _a.labelProps,
      labelProps = _b === void 0 ? {} : _b,
      row = _a.row,
      props = __rest(_a, ["label", "labelProps", "row"]);

  labelProps.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, row ? "form-group-row" : "");
  return jsxRuntime.exports.jsxs(InputLabel, __assign({}, labelProps, {
    children: [jsxRuntime.exports.jsx(Checkbox, __assign({}, props), void 0), "\xA0", label]
  }), void 0);
}

function FormCheckboxGroup(_a) {
  var name = _a.name,
      label = _a.label,
      options = _a.options,
      row = _a.row,
      onChange = _a.onChange,
      onSimpleChange = _a.onSimpleChange,
      value = _a.value,
      validity = _a.validity,
      pairProps = _a.pairProps,
      labelProps = _a.labelProps,
      groupProps = _a.groupProps,
      checkboxProps = _a.checkboxProps,
      disabled = _a.disabled,
      bluelibClassNames = _a.bluelibClassNames,
      customColor = _a.customColor;

  if (!name) {
    name = UUID__namespace.v4();
  }

  var checkboxes = options.map(function (option) {
    return jsxRuntime.exports.jsx(LabelledCheckbox, __assign({
      label: option,
      value: option,
      row: row,
      checked: value ? value.includes(option) : undefined,
      name: name,
      disabled: disabled
    }, checkboxProps), void 0);
  });
  var onChangeWrapped = React__namespace.useCallback(function (event) {
    if (onChange) onChange(event);

    if (value && onSimpleChange) {
      if (event.target.checked) {
        onSimpleChange(value.concat(event.target.value));
      } else {
        var valueCopy = Array.from(value);
        var indexOf = valueCopy.indexOf(event.target.value);
        if (indexOf !== -1) valueCopy.splice(indexOf, 1);
        onSimpleChange(valueCopy);
      }
    }
  }, [onChange, value, onSimpleChange]);

  var group = jsxRuntime.exports.jsx(FormGroup, __assign({
    onChange: onChangeWrapped,
    value: value
  }, groupProps, {
    children: checkboxes
  }), void 0);

  return jsxRuntime.exports.jsx(FormPair, __assign({
    label: jsxRuntime.exports.jsx(FormLabel, __assign({}, labelProps, {
      children: label
    }), void 0),
    input: group,
    validity: validity,
    bluelibClassNames: bluelibClassNames,
    customColor: customColor
  }, pairProps), void 0);
}

function Field(_a) {
  var onChange = _a.onChange,
      onSimpleChange = _a.onSimpleChange,
      props = __rest(_a, ["onChange", "onSimpleChange"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "input", "input-field");
  var onChangeWrapped = React__namespace.useCallback(function (event) {
    if (onChange) onChange(event);
    if (onSimpleChange) onSimpleChange(event.target.value);
  }, [onChange, onSimpleChange]);
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "input",
    onChange: onChangeWrapped
  }, props), void 0);
}

function FormField(_a) {
  var label = _a.label,
      validity = _a.validity,
      pairProps = _a.pairProps,
      labelProps = _a.labelProps,
      props = __rest(_a, ["label", "validity", "pairProps", "labelProps"]);

  return jsxRuntime.exports.jsx(FormPair, __assign({
    label: jsxRuntime.exports.jsx(FormLabel, __assign({}, labelProps, {
      children: label
    }), void 0),
    input: jsxRuntime.exports.jsx(Field, __assign({}, props), void 0),
    validity: validity
  }, pairProps), void 0);
}

function Option(_a) {
  var value = _a.value,
      props = __rest(_a, ["value"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "input-option");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "option"
  }, props, {
    children: value
  }), void 0);
}

function OptionGroup(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "input-optgroup");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "optgroup"
  }, props), void 0);
}

function Multiselect(_a) {
  var onChange = _a.onChange,
      onSimpleChange = _a.onSimpleChange,
      props = __rest(_a, ["onChange", "onSimpleChange"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "input", "input-multiselect");
  var onChangeWrapped = React__namespace.useCallback(function (event) {
    if (onChange) onChange(event);
    if (onSimpleChange) onSimpleChange(Array.from(event.target.selectedOptions).map(function (option) {
      return option.value;
    }));
  }, [onChange, onSimpleChange]);
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "select",
    multiple: true,
    onChange: onChangeWrapped
  }, props), void 0);
}
Multiselect.Option = Option;
Multiselect.Group = OptionGroup;

function FormMultiselect(_a) {
  var label = _a.label,
      validity = _a.validity,
      pairProps = _a.pairProps,
      labelProps = _a.labelProps,
      onSimpleChange = _a.onSimpleChange,
      options = _a.options,
      value = _a.value,
      props = __rest(_a, ["label", "validity", "pairProps", "labelProps", "onSimpleChange", "options", "value"]);

  var onSimpleChangeWrapped = React__namespace.useCallback(function (values) {
    onSimpleChange === null || onSimpleChange === void 0 ? void 0 : onSimpleChange(values.map(function (val) {
      return options[val];
    }));
  }, [onSimpleChange, options]);
  var optionComponents = React__namespace.useMemo(function () {
    return Object.entries(options).map(function (_a) {
      var optKey = _a[0],
          optValue = _a[1];
      return jsxRuntime.exports.jsx(Multiselect.Option, {
        value: optKey,
        selected: value === null || value === void 0 ? void 0 : value.includes(optValue)
      }, optKey);
    });
  }, [options]);
  return jsxRuntime.exports.jsx(FormPair, __assign({
    label: jsxRuntime.exports.jsx(FormLabel, __assign({}, labelProps, {
      children: label
    }), void 0),
    input: jsxRuntime.exports.jsx(Multiselect, __assign({
      onSimpleChange: onSimpleChangeWrapped
    }, props, {
      children: optionComponents
    }), void 0),
    validity: validity
  }, pairProps), void 0);
}

function Radio(_a) {
  var onChange = _a.onChange,
      onSimpleChange = _a.onSimpleChange,
      props = __rest(_a, ["onChange", "onSimpleChange"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "input", "input-radio");
  var onChangeWrapped = React__namespace.useCallback(function (event) {
    if (onChange) onChange(event);
    if (onSimpleChange) onSimpleChange(event.target.value);
  }, [onChange, onSimpleChange]);
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "input",
    type: "radio",
    onChange: onChangeWrapped
  }, props), void 0);
}

function LabelledRadio(_a) {
  var label = _a.label,
      _b = _a.labelProps,
      labelProps = _b === void 0 ? {} : _b,
      row = _a.row,
      props = __rest(_a, ["label", "labelProps", "row"]);

  labelProps.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, row ? "form-group-row" : "");
  return jsxRuntime.exports.jsxs(InputLabel, __assign({}, labelProps, {
    children: [jsxRuntime.exports.jsx(Radio, __assign({}, props), void 0), "\xA0", label]
  }), void 0);
}

function FormRadioGroup(_a) {
  var name = _a.name,
      label = _a.label,
      options = _a.options,
      row = _a.row,
      onChange = _a.onChange,
      onSimpleChange = _a.onSimpleChange,
      value = _a.value,
      validity = _a.validity,
      pairProps = _a.pairProps,
      labelProps = _a.labelProps,
      groupProps = _a.groupProps,
      radioProps = _a.radioProps,
      disabled = _a.disabled,
      bluelibClassNames = _a.bluelibClassNames,
      customColor = _a.customColor;

  if (!name) {
    name = UUID__namespace.v4();
  }

  var radios = options.map(function (option) {
    return jsxRuntime.exports.jsx(LabelledRadio, __assign({
      label: option,
      value: option,
      row: row,
      checked: value ? value === option : undefined,
      name: name,
      disabled: disabled
    }, radioProps), void 0);
  });
  var onChangeWrapped = React__namespace.useCallback(function (event) {
    if (onChange) onChange(event);
    if (onSimpleChange) onSimpleChange(event.target.value);
  }, [onChange, onSimpleChange]);

  var group = jsxRuntime.exports.jsx(FormGroup, __assign({
    onChange: onChangeWrapped,
    value: value
  }, groupProps, {
    children: radios
  }), void 0);

  return jsxRuntime.exports.jsx(FormPair, __assign({
    label: jsxRuntime.exports.jsx(FormLabel, __assign({}, labelProps, {
      children: label
    }), void 0),
    input: group,
    validity: validity,
    bluelibClassNames: bluelibClassNames,
    customColor: customColor
  }, pairProps), void 0);
}

function FormRow(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "form-row");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "div"
  }, props), void 0);
}

function Select(_a) {
  var onChange = _a.onChange,
      onSimpleChange = _a.onSimpleChange,
      props = __rest(_a, ["onChange", "onSimpleChange"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "input", "input-select");
  var onChangeWrapped = React__namespace.useCallback(function (event) {
    if (onChange) onChange(event);
    if (onSimpleChange) onSimpleChange(event.target.value);
  }, [onChange, onSimpleChange]);
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "select",
    multiple: false,
    required: true,
    onChange: onChangeWrapped
  }, props), void 0);
}
Select.Option = Option;
Select.Group = OptionGroup;

function FormSelect(_a) {
  var label = _a.label,
      validity = _a.validity,
      options = _a.options,
      pairProps = _a.pairProps,
      labelProps = _a.labelProps,
      onSimpleChange = _a.onSimpleChange,
      value = _a.value,
      props = __rest(_a, ["label", "validity", "options", "pairProps", "labelProps", "onSimpleChange", "value"]);

  var onSimpleChangeWrapped = React__namespace.useCallback(function (value) {
    onSimpleChange === null || onSimpleChange === void 0 ? void 0 : onSimpleChange(options[value]);
  }, [onSimpleChange, options]);
  var optionComponents = React__namespace.useMemo(function () {
    return Object.entries(options).map(function (_a) {
      var optKey = _a[0],
          optValue = _a[1];
      return jsxRuntime.exports.jsx(Select.Option, {
        value: optKey,
        selected: value === optValue
      }, optKey);
    });
  }, [options]);
  return jsxRuntime.exports.jsx(FormPair, __assign({
    label: jsxRuntime.exports.jsx(FormLabel, __assign({}, labelProps, {
      children: label
    }), void 0),
    input: jsxRuntime.exports.jsx(Select, __assign({
      onSimpleChange: onSimpleChangeWrapped
    }, props, {
      children: optionComponents
    }), void 0),
    validity: validity
  }, pairProps), void 0);
}

function Button(_a) {
  var onClick = _a.onClick,
      disabled = _a.disabled,
      children = _a.children,
      props = __rest(_a, ["onClick", "disabled", "children"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "input", "input-button");
  var onClickWrapped = disabled ? function () {} : onClick;
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "button",
    type: "button",
    onClick: onClickWrapped,
    disabled: disabled
  }, props, {
    children: children
  }), void 0);
}

function Form(_a) {
  var onSubmit = _a.onSubmit,
      props = __rest(_a, ["onSubmit"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "form");
  var onSubmitPreventDefault = React__namespace.useCallback(function (event) {
    if (onSubmit) onSubmit(event);
    event.preventDefault();
  }, [onSubmit]);
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "form",
    onSubmit: onSubmitPreventDefault
  }, props), void 0);
}
Form.Area = FormArea;
Form.Checkboxes = FormCheckboxGroup;
Form.Field = FormField;
Form.Multiselect = FormMultiselect;
Form.Radios = FormRadioGroup;
Form.Row = FormRow;
Form.Select = FormSelect;
Form.Button = Button;
Form.Internals = {
  Label: FormLabel,
  Pair: FormPair,
  Group: FormGroup
};

var LIMIT_CLASSES = {
  full: "",
  half: "image-limit-half",
  quarter: "image-limit-quarter"
};
function Image(_a) {
  var _b = _a.limit,
      limit = _b === void 0 ? "full" : _b,
      props = __rest(_a, ["limit"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "image");

  if (limit) {
    props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, LIMIT_CLASSES[limit]);
  }

  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "img"
  }, props), void 0);
}

function BaseLayout(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "layout");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "div"
  }, props), void 0);
}

function LayoutFillSingle(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "layout-fill-single");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "div"
  }, props), void 0);
}

function LayoutFill(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "layout-fill");
  return jsxRuntime.exports.jsx(BaseLayout, __assign({}, props), void 0);
}
LayoutFill.Single = LayoutFillSingle;

function LayoutThreeColLeft(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "layout-threecol-left");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "div"
  }, props), void 0);
}

function LayoutThreeColCenter(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "layout-threecol-center");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "div"
  }, props), void 0);
}

function LayoutThreeColRight(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "layout-threecol-right");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "div"
  }, props), void 0);
}

function LayoutThreeCol(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "layout-threecol");
  return jsxRuntime.exports.jsx(BaseLayout, __assign({}, props), void 0);
}
LayoutThreeCol.Left = LayoutThreeColLeft;
LayoutThreeCol.Center = LayoutThreeColCenter;
LayoutThreeCol.Right = LayoutThreeColRight;

function Footer(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "page-footer");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "footer"
  }, props), void 0);
}

function ListTerm(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "list-description-term");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "dt"
  }, props), void 0);
}

function ListDetails(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "list-description-details");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "dd"
  }, props), void 0);
}

function ListDescription(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "list", "list-description");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "dl"
  }, props), void 0);
}
ListDescription.Term = ListTerm;
ListDescription.Details = ListDetails;

function ListItem(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "list-item");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "li"
  }, props), void 0);
}

function ListOrdered(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "list", "list-ordered");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "ol"
  }, props), void 0);
}
ListOrdered.Item = ListItem;

function ListUnordered(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "list", "list-unordered");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "ul"
  }, props), void 0);
}
ListUnordered.Item = ListItem;

function Panel(_a) {
  var todo = _a.todo,
      _b = _a.warn,
      warn = _b === void 0 ? true : _b,
      props = __rest(_a, ["todo", "warn"]);

  if (todo && warn) {
    console.warn("TODO: ".concat(props.children));
  }

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "panel", todo ? "todo" : "");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "section"
  }, props), void 0);
}

function Box(_a) {
  var todo = _a.todo,
      _b = _a.warn,
      warn = _b === void 0 ? true : _b,
      props = __rest(_a, ["todo", "warn"]);

  if (todo && warn) {
    console.warn("TODO: ".concat(props.children));
  }

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "panel-box", todo ? "todo" : "");
  return jsxRuntime.exports.jsx(Panel, __assign({}, props), void 0);
}

function Dialog(_a) {
  var todo = _a.todo,
      _b = _a.warn,
      warn = _b === void 0 ? true : _b,
      props = __rest(_a, ["todo", "warn"]);

  if (todo && warn) {
    console.warn("TODO: ".concat(props.children));
  }

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "panel-dialog", todo ? "todo" : "");
  return jsxRuntime.exports.jsx(Panel, __assign({}, props), void 0);
}

function Parenthesis(_a) {
  var todo = _a.todo,
      _b = _a.warn,
      warn = _b === void 0 ? true : _b,
      props = __rest(_a, ["todo", "warn"]);

  if (todo && warn) {
    console.warn("TODO: ".concat(props.children));
  }

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "panel-parenthesis", todo ? "todo" : "");
  return jsxRuntime.exports.jsx(Panel, __assign({}, props), void 0);
}

function Abbreviation(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-abbr");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "abbr"
  }, props), void 0);
}

function BringAttention(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-b");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "b"
  }, props), void 0);
}

function Cite(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-cite");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "cite"
  }, props), void 0);
}

function Code(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-code");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "code"
  }, props), void 0);
}

function Definition(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-dfn");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "dfn"
  }, props), void 0);
}

function Emphasis(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-em");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "em"
  }, props), void 0);
}

function Idiomatic(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-i");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "i"
  }, props), void 0);
}

function Mark(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-mark");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "mark"
  }, props), void 0);
}

function Quote(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-q");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "q"
  }, props), void 0);
}

function Sample(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-samp");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "samp"
  }, props), void 0);
}

function Strikethrough(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-s");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "s"
  }, props), void 0);
}

function Strong(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-strong");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "strong"
  }, props), void 0);
}

function UAnnotation(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-u");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "u"
  }, props), void 0);
}

function Variable(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "semantic-var");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "var"
  }, props), void 0);
}

var WEIGHT_CLASSES = {
  light: "separator-light",
  regular: "",
  heavy: "separator-heavy"
};
function Separator(_a) {
  var _b = _a.weight,
      weight = _b === void 0 ? "regular" : _b,
      props = __rest(_a, ["weight"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "separator", WEIGHT_CLASSES[weight]);
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "hr"
  }, props), void 0);
}

var TABLE_CAPTION_CLASSES = {
  top: "table-caption-top",
  bottom: "table-caption-bottom"
};
function TableCaption(_a) {
  var _b = _a.position,
      position = _b === void 0 ? "top" : _b,
      props = __rest(_a, ["position"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "table-caption", TABLE_CAPTION_CLASSES[position]);
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "caption"
  }, props), void 0);
}

function TableHeader(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "table-header");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "thead"
  }, props), void 0);
}

function TableBody(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "table-body");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "tbody"
  }, props), void 0);
}

function TableFooter(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "table-footer");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "tfoot"
  }, props), void 0);
}

function TableRow(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "table-row");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "tr"
  }, props), void 0);
}

function TableCell(_a) {
  var _b = _a.head,
      head = _b === void 0 ? false : _b,
      _c = _a.mark,
      mark = _c === void 0 ? false : _c,
      props = __rest(_a, ["head", "mark"]);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, head ? "table-head" : "table-data", mark ? "table-mark" : "");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: head ? "th" : "td"
  }, props), void 0);
}

function Table(_a) {
  var props = __rest(_a, []);

  props.bluelibClassNames = mergeClassNames__default["default"](props.bluelibClassNames, "table");
  return jsxRuntime.exports.jsx(BaseElement, __assign({
    kind: "table"
  }, props), void 0);
}
Table.Caption = TableCaption;
Table.Header = TableHeader;
Table.Body = TableBody;
Table.Footer = TableFooter;
Table.Row = TableRow;
Table.Cell = TableCell;

var slicedToArray = {exports: {}};

var arrayWithHoles = {exports: {}};

(function (module) {
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(arrayWithHoles));

var iterableToArrayLimit = {exports: {}};

(function (module) {
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(iterableToArrayLimit));

var unsupportedIterableToArray = {exports: {}};

var arrayLikeToArray = {exports: {}};

(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(arrayLikeToArray));

(function (module) {
var arrayLikeToArray$1 = arrayLikeToArray.exports;

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray$1(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(unsupportedIterableToArray));

var nonIterableRest = {exports: {}};

(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(nonIterableRest));

(function (module) {
var arrayWithHoles$1 = arrayWithHoles.exports;

var iterableToArrayLimit$1 = iterableToArrayLimit.exports;

var unsupportedIterableToArray$1 = unsupportedIterableToArray.exports;

var nonIterableRest$1 = nonIterableRest.exports;

function _slicedToArray(arr, i) {
  return arrayWithHoles$1(arr) || iterableToArrayLimit$1(arr, i) || unsupportedIterableToArray$1(arr, i) || nonIterableRest$1();
}

module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(slicedToArray));

var _slicedToArray = /*@__PURE__*/getDefaultExportFromCjs(slicedToArray.exports);

// FIXME: Converting this to TypeScript breaks the transpiler. Why? I have absolutely no idea. JS is a mess.
function split(obj) {
  for (var _len = arguments.length, keyGroups = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keyGroups[_key - 1] = arguments[_key];
  }

  var results = keyGroups.map(function (_) {
    return {};
  });
  var other = {};
  Object.entries(obj).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    var matched = false;
    keyGroups.forEach(function (keyGroup, index) {
      if (keyGroup.includes(k)) {
        results[index][k] = v;
        matched = true;
      }
    });

    if (!matched) {
      other[k] = v;
    }
  });
  results.push(other);
  return results;
}
function splitInTwo(obj, keyGroup) {
  return split(obj, keyGroup);
}

var css_248z$4 = ".paper-module_bluelib__EoA2P {\n  --bluelib-background-r: 255;\n  --bluelib-background-g: 255;\n  --bluelib-background-b: 255;\n  --bluelib-foreground-r: 24;\n  --bluelib-foreground-g: 24;\n  --bluelib-foreground-b: 24;\n  --bluelib-accent-r: 24;\n  --bluelib-accent-g: 24;\n  --bluelib-accent-b: 24;\n  --bluelib-link-r: 0;\n  --bluelib-link-g: 147;\n  --bluelib-link-b: 147;\n  --bluelib-broken-r: 245;\n  --bluelib-broken-g: 111;\n  --bluelib-broken-b: 0;\n  --bluelib-visited-r: 9;\n  --bluelib-visited-g: 101;\n  --bluelib-visited-b: 156;\n  --bluelib-download-r: 0;\n  --bluelib-download-g: 164;\n  --bluelib-download-b: 106;\n  --bluelib-red-r: 200;\n  --bluelib-red-g: 0;\n  --bluelib-red-b: 0;\n  --bluelib-orange-r: 200;\n  --bluelib-orange-g: 165;\n  --bluelib-orange-b: 0;\n  --bluelib-yellow-r: 200;\n  --bluelib-yellow-g: 200;\n  --bluelib-yellow-b: 0;\n  --bluelib-lime-r: 0;\n  --bluelib-lime-g: 200;\n  --bluelib-lime-b: 0;\n  --bluelib-cyan-r: 0;\n  --bluelib-cyan-g: 200;\n  --bluelib-cyan-b: 200;\n  --bluelib-blue-r: 0;\n  --bluelib-blue-g: 0;\n  --bluelib-blue-b: 200;\n  --bluelib-magenta-r: 200;\n  --bluelib-magenta-g: 0;\n  --bluelib-magenta-b: 200;\n  --bluelib-gray-r: 128;\n  --bluelib-gray-g: 128;\n  --bluelib-gray-b: 128;\n  --bluelib-polarity: -1;\n  --bluelib-title-family: sans-serif;\n  --bluelib-title-weight: bold;\n  --bluelib-text-family: sans-serif;\n  --bluelib-text-weight: normal;\n  --bluelib-code-family: monospace;\n  --bluelib-code-weight: normal;\n}";
var PaperTheme = {"bluelib":"paper-module_bluelib__EoA2P"};
styleInject(css_248z$4);

var css_248z$3 = "@font-face {\n  font-family: 'Fira Code';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firacode/v12/uU9dCBsR6Z2vfE9aq3bpdva8iVtipIat--AvNZ-YE8Y.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 100;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9A4kDNxMZdWfMOD5VvkrCqYTc.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 200;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrAGQBf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 300;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBiQxf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9C4kDNxMZdWfMOD5VvkojO.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrA6Qhf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrAWRRf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrByRBf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 800;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBuRxf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBKRhf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9C4kDNxMZdWfMOD5Vn9IjO.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 200;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnWKnuQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnPKruQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9E4kDNxMZdWfMOD5VfkA.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnZKvuQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnSKzuQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnLK3uQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 800;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnMK7uQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnFK_uQQ.ttf) format('truetype');\n}\n.royalblue-module_bluelib__0YhrA {\n  --bluelib-background-r: 13;\n  --bluelib-background-g: 25;\n  --bluelib-background-b: 59;\n  --bluelib-foreground-r: 160;\n  --bluelib-foreground-g: 204;\n  --bluelib-foreground-b: 255;\n  --bluelib-accent-r: 255;\n  --bluelib-accent-g: 255;\n  --bluelib-accent-b: 255;\n  --bluelib-link-r: 0;\n  --bluelib-link-g: 202;\n  --bluelib-link-b: 202;\n  --bluelib-broken-r: 255;\n  --bluelib-broken-g: 116;\n  --bluelib-broken-b: 0;\n  --bluelib-visited-r: 12;\n  --bluelib-visited-g: 134;\n  --bluelib-visited-b: 207;\n  --bluelib-download-r: 0;\n  --bluelib-download-g: 211;\n  --bluelib-download-b: 137;\n  --bluelib-red-r: 255;\n  --bluelib-red-g: 125;\n  --bluelib-red-b: 125;\n  --bluelib-orange-r: 255;\n  --bluelib-orange-g: 187;\n  --bluelib-orange-b: 125;\n  --bluelib-yellow-r: 255;\n  --bluelib-yellow-g: 255;\n  --bluelib-yellow-b: 125;\n  --bluelib-lime-r: 125;\n  --bluelib-lime-g: 255;\n  --bluelib-lime-b: 125;\n  --bluelib-cyan-r: 125;\n  --bluelib-cyan-g: 255;\n  --bluelib-cyan-b: 255;\n  --bluelib-blue-r: 125;\n  --bluelib-blue-g: 125;\n  --bluelib-blue-b: 255;\n  --bluelib-magenta-r: 255;\n  --bluelib-magenta-g: 125;\n  --bluelib-magenta-b: 255;\n  --bluelib-gray-r: 187;\n  --bluelib-gray-g: 187;\n  --bluelib-gray-b: 187;\n  --bluelib-polarity: 1;\n  --bluelib-title-family: \"Fira Sans\", sans-serif;\n  --bluelib-title-weight: 500;\n  --bluelib-text-family: \"Fira Sans\", sans-serif;\n  --bluelib-text-weight: 400;\n  --bluelib-code-family: \"Fira Code\", monospace;\n  --bluelib-code-weight: 400;\n}";
var RoyalBlueTheme = {"bluelib":"royalblue-module_bluelib__0YhrA"};
styleInject(css_248z$3);

var css_248z$2 = "@font-face {\n  font-family: 'Roboto Mono';\n  font-style: italic;\n  font-weight: 100;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrlnAeW9.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: italic;\n  font-weight: 200;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrnnAOW9.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: italic;\n  font-weight: 300;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrk5AOW9.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrlnAOW9.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: italic;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrlVAOW9.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: italic;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrm5B-W9.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrmAB-W9.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vuPQw.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 200;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_XvqPQw.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_gPqPQw.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vqPQw.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_7PqPQw.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_AP2PQw.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_Of2PQw.ttf) format('truetype');\n}\n.hacker-module_bluelib__BwgEV {\n  --bluelib-background-r: 4;\n  --bluelib-background-g: 4;\n  --bluelib-background-b: 4;\n  --bluelib-foreground-r: 0;\n  --bluelib-foreground-g: 255;\n  --bluelib-foreground-b: 0;\n  --bluelib-accent-r: 0;\n  --bluelib-accent-g: 255;\n  --bluelib-accent-b: 0;\n  --bluelib-link-r: 127;\n  --bluelib-link-g: 255;\n  --bluelib-link-b: 127;\n  --bluelib-broken-r: 255;\n  --bluelib-broken-g: 0;\n  --bluelib-broken-b: 0;\n  --bluelib-visited-r: 64;\n  --bluelib-visited-g: 180;\n  --bluelib-visited-b: 64;\n  --bluelib-download-r: 255;\n  --bluelib-download-g: 255;\n  --bluelib-download-b: 255;\n  --bluelib-red-r: 255;\n  --bluelib-red-g: 125;\n  --bluelib-red-b: 125;\n  --bluelib-orange-r: 255;\n  --bluelib-orange-g: 187;\n  --bluelib-orange-b: 125;\n  --bluelib-yellow-r: 255;\n  --bluelib-yellow-g: 255;\n  --bluelib-yellow-b: 125;\n  --bluelib-lime-r: 125;\n  --bluelib-lime-g: 255;\n  --bluelib-lime-b: 125;\n  --bluelib-cyan-r: 125;\n  --bluelib-cyan-g: 255;\n  --bluelib-cyan-b: 255;\n  --bluelib-blue-r: 125;\n  --bluelib-blue-g: 125;\n  --bluelib-blue-b: 255;\n  --bluelib-magenta-r: 255;\n  --bluelib-magenta-g: 125;\n  --bluelib-magenta-b: 255;\n  --bluelib-gray-r: 187;\n  --bluelib-gray-g: 187;\n  --bluelib-gray-b: 187;\n  --bluelib-polarity: 1;\n  --bluelib-title-family: \"Roboto Mono\", monospace;\n  --bluelib-title-weight: 500;\n  --bluelib-text-family: \"Roboto Mono\", monospace;\n  --bluelib-text-weight: 400;\n  --bluelib-code-family: \"Roboto Mono\", monospace;\n  --bluelib-code-weight: 400;\n}";
var HackerTheme = {"bluelib":"hacker-module_bluelib__BwgEV"};
styleInject(css_248z$2);

var css_248z$1 = "@font-face {\n  font-family: 'Fira Code';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firacode/v12/uU9dCBsR6Z2vfE9aq3bpdva8iVtipIat--AvNZ-YE8Y.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 100;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9A4kDNxMZdWfMOD5VvkrCqYTc.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 200;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrAGQBf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 300;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBiQxf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9C4kDNxMZdWfMOD5VvkojO.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrA6Qhf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrAWRRf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrByRBf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 800;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBuRxf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBKRhf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9C4kDNxMZdWfMOD5Vn9IjO.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 200;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnWKnuQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnPKruQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9E4kDNxMZdWfMOD5VfkA.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnZKvuQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnSKzuQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnLK3uQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 800;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnMK7uQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnFK_uQQ.ttf) format('truetype');\n}\n.sophon-module_bluelib__vVPeU {\n  --bluelib-background-r: 0;\n  --bluelib-background-g: 0;\n  --bluelib-background-b: 20;\n  --bluelib-foreground-r: 45;\n  --bluelib-foreground-g: 154;\n  --bluelib-foreground-b: 255;\n  --bluelib-accent-r: 250;\n  --bluelib-accent-g: 250;\n  --bluelib-accent-b: 250;\n  --bluelib-link-r: 0;\n  --bluelib-link-g: 202;\n  --bluelib-link-b: 202;\n  --bluelib-broken-r: 255;\n  --bluelib-broken-g: 116;\n  --bluelib-broken-b: 0;\n  --bluelib-visited-r: 12;\n  --bluelib-visited-g: 134;\n  --bluelib-visited-b: 207;\n  --bluelib-download-r: 0;\n  --bluelib-download-g: 211;\n  --bluelib-download-b: 137;\n  --bluelib-red-r: 255;\n  --bluelib-red-g: 125;\n  --bluelib-red-b: 125;\n  --bluelib-orange-r: 255;\n  --bluelib-orange-g: 187;\n  --bluelib-orange-b: 125;\n  --bluelib-yellow-r: 255;\n  --bluelib-yellow-g: 255;\n  --bluelib-yellow-b: 125;\n  --bluelib-lime-r: 125;\n  --bluelib-lime-g: 255;\n  --bluelib-lime-b: 125;\n  --bluelib-cyan-r: 125;\n  --bluelib-cyan-g: 255;\n  --bluelib-cyan-b: 255;\n  --bluelib-blue-r: 125;\n  --bluelib-blue-g: 125;\n  --bluelib-blue-b: 255;\n  --bluelib-magenta-r: 255;\n  --bluelib-magenta-g: 125;\n  --bluelib-magenta-b: 255;\n  --bluelib-gray-r: 187;\n  --bluelib-gray-g: 187;\n  --bluelib-gray-b: 187;\n  --bluelib-polarity: 1;\n  --bluelib-title-family: \"Fira Sans\", sans-serif;\n  --bluelib-title-weight: 500;\n  --bluelib-text-family: \"Fira Sans\", sans-serif;\n  --bluelib-text-weight: 400;\n  --bluelib-code-family: \"Fira Code\", monospace;\n  --bluelib-code-weight: 400;\n}";
var SophonTheme = {"bluelib":"sophon-module_bluelib__vVPeU"};
styleInject(css_248z$1);

var css_248z = "@font-face {\n  font-family: 'Fira Code';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firacode/v12/uU9dCBsR6Z2vfE9aq3bpdva8iVtipIat--AvNZ-YE8Y.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 100;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9A4kDNxMZdWfMOD5VvkrCqYTc.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 200;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrAGQBf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 300;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBiQxf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9C4kDNxMZdWfMOD5VvkojO.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrA6Qhf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrAWRRf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrByRBf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 800;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBuRxf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: italic;\n  font-weight: 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9f4kDNxMZdWfMOD5VvkrBKRhf_.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9C4kDNxMZdWfMOD5Vn9IjO.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 200;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnWKnuQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnPKruQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9E4kDNxMZdWfMOD5VfkA.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnZKvuQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnSKzuQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnLK3uQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 800;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnMK7uQQ.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Fira Sans';\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/firasans/v11/va9B4kDNxMZdWfMOD5VnFK_uQQ.ttf) format('truetype');\n}\n.amber-module_bluelib__dHe95 {\n  --bluelib-background-r: 39;\n  --bluelib-background-g: 33;\n  --bluelib-background-b: 33;\n  --bluelib-foreground-r: 225;\n  --bluelib-foreground-g: 80;\n  --bluelib-foreground-b: 11;\n  --bluelib-accent-r: 246;\n  --bluelib-accent-g: 233;\n  --bluelib-accent-b: 233;\n  --bluelib-link-r: 255;\n  --bluelib-link-g: 187;\n  --bluelib-link-b: 154;\n  --bluelib-broken-r: 218;\n  --bluelib-broken-g: 153;\n  --bluelib-broken-b: 246;\n  --bluelib-visited-r: 255;\n  --bluelib-visited-g: 239;\n  --bluelib-visited-b: 154;\n  --bluelib-download-r: 149;\n  --bluelib-download-g: 246;\n  --bluelib-download-b: 212;\n  --bluelib-red-r: 255;\n  --bluelib-red-g: 80;\n  --bluelib-red-b: 80;\n  --bluelib-orange-r: 255;\n  --bluelib-orange-g: 175;\n  --bluelib-orange-b: 80;\n  --bluelib-yellow-r: 255;\n  --bluelib-yellow-g: 255;\n  --bluelib-yellow-b: 80;\n  --bluelib-lime-r: 80;\n  --bluelib-lime-g: 255;\n  --bluelib-lime-b: 80;\n  --bluelib-cyan-r: 80;\n  --bluelib-cyan-g: 255;\n  --bluelib-cyan-b: 255;\n  --bluelib-blue-r: 80;\n  --bluelib-blue-g: 80;\n  --bluelib-blue-b: 255;\n  --bluelib-magenta-r: 255;\n  --bluelib-magenta-g: 80;\n  --bluelib-magenta-b: 255;\n  --bluelib-gray-r: 187;\n  --bluelib-gray-g: 187;\n  --bluelib-gray-b: 187;\n  --bluelib-polarity: 1;\n  --bluelib-title-family: \"Fira Sans\", sans-serif;\n  --bluelib-title-weight: 500;\n  --bluelib-text-family: \"Fira Sans\", sans-serif;\n  --bluelib-text-weight: 400;\n  --bluelib-code-family: \"Fira Code\", monospace;\n  --bluelib-code-weight: 400;\n}";
var GestioneAmberTheme = {"bluelib":"amber-module_bluelib__dHe95"};
styleInject(css_248z);

var BuiltinThemes = {
  "paper": PaperTheme,
  "royalblue": RoyalBlueTheme,
  "hacker": HackerTheme,
  "sophon": SophonTheme,
  "amber": GestioneAmberTheme
};
function useBluelib(ref, options) {
  React__namespace.useEffect(function () {
    var target = ref.current;
    if (!target) return;
    var extraClassName = [rootToModule("bluelib")];
    if (options.theme) extraClassName.push(BuiltinThemes[options.theme]["bluelib"]);
    var extraStyle = {};
    if (options.backgroundColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("background", options.backgroundColor));
    if (options.foregroundColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("foreground", options.foregroundColor));
    if (options.accentColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("accent", options.accentColor));
    if (options.linkColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("link", options.linkColor));
    if (options.brokenColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("broken", options.brokenColor));
    if (options.visitedColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("visited", options.visitedColor));
    if (options.downloadColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("download", options.downloadColor));
    if (options.redColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("red", options.redColor));
    if (options.orangeColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("orange", options.orangeColor));
    if (options.yellowColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("yellow", options.yellowColor));
    if (options.limeColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("lime", options.limeColor));
    if (options.cyanColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("cyan", options.cyanColor));
    if (options.blueColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("blue", options.blueColor));
    if (options.magentaColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("magenta", options.magentaColor));
    if (options.grayColor) extraStyle = __assign(__assign({}, extraStyle), colorToBluelibStyle("gray", options.grayColor));
    target.classList.forEach(function (className) {
      if (Object.values(BuiltinThemes).map(function (a) {
        return a["bluelib"];
      }).includes(className)) {
        target.classList.remove(className);
      }
    });
    extraClassName.forEach(function (className) {
      target.classList.add(className);
    });
    Object.entries(extraStyle).forEach(function (_a) {
      var k = _a[0],
          v = _a[1];
      target.style.setProperty(k, v.toString(), "");
    });
  }, [ref, options]);
}

var Bluelib = function Bluelib(props) {
  var _a = splitInTwo(props, ["theme", "backgroundColor", "foregroundColor", "accentColor", "linkColor", "brokenColor", "visitedColor", "downloadColor", "redColor", "orangeColor", "yellowColor", "limeColor", "cyanColor", "blueColor", "magentaColor", "grayColor", "polarity"]),
      useBluelibOptions = _a[0],
      baseElementProps = _a[1];

  var ref = React__namespace.useRef(null);
  var element = React__namespace.useMemo(function () {
    return jsxRuntime.exports.jsx(BaseElement, __assign({
      childRef: ref,
      kind: "div"
    }, baseElementProps), void 0);
  }, [ref, baseElementProps]);
  useBluelib(ref, useBluelibOptions);
  return element;
};
Bluelib.Element = BaseElement;

var asyncToGenerator = {exports: {}};

(function (module) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(asyncToGenerator));

var _asyncToGenerator = /*@__PURE__*/getDefaultExportFromCjs(asyncToGenerator.exports);

var runtime = {exports: {}};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (module) {
var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
}(runtime));

var regenerator = runtime.exports;

/**
 * Hook similar to {@link useCallback} that converts a syncronous function into an asyncronous one.
 *
 * @todo Improve this docstring.
 * @todo I have no idea of how to write this in TypeScript.
 * @param func The function to convert.
 */

function usePromise(func) {
  return React.useMemo(function () {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var _args = arguments;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return func.apply(void 0, _args);

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, [func]);
}

/**
 * Hook similar to {@link useState} for handling the validation of form fields.
 *
 * @param def - Default value for the state.
 * @param validator - The {@link Validator} to apply.
 */

function useFormState(def, validator) {
  var _this = this;

  var _a = React__namespace.useState(def),
      value = _a[0],
      setValue = _a[1];

  var _b = React__namespace.useState(null),
      validity = _b[0],
      setValidity = _b[1];

  var trueValidator = usePromise(validator);
  var validate = React__namespace.useCallback(function (value, abort) {
    return __awaiter(_this, void 0, void 0, function () {
      var result;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setValidity(null);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , trueValidator(value, abort)];

          case 2:
            result = _a.sent();
            return [3
            /*break*/
            , 4];

          case 3:
            _a.sent();
            result = false;
            return [3
            /*break*/
            , 4];

          case 4:
            if (!abort.aborted) {
              setValidity(result);
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  }, []);
  React__namespace.useEffect(function () {
    var abort = new AbortController();
    validate(value, abort.signal);
    return function () {
      abort.abort();
    };
  }, [validate, value]);
  return {
    value: value,
    onSimpleChange: setValue,
    validity: validity
  };
}

function useBluelibInBody(theme) {
  var ref = React.useRef(null);
  React.useEffect(function () {
    ref.current = document.body;
  }, [ref]);
  useBluelib(ref, {
    theme: theme
  });
}

exports.Abbreviation = Abbreviation;
exports.Anchor = Anchor;
exports.Area = Area;
exports.BaseElement = BaseElement;
exports.Bluelib = Bluelib;
exports.Box = Box;
exports.BringAttention = BringAttention;
exports.Button = Button;
exports.Chapter = Chapter;
exports.Checkbox = Checkbox;
exports.Cite = Cite;
exports.Code = Code;
exports.Definition = Definition;
exports.Details = Details;
exports.Dialog = Dialog;
exports.Emphasis = Emphasis;
exports.Field = Field;
exports.Footer = Footer;
exports.Form = Form;
exports.Heading = Heading;
exports.Idiomatic = Idiomatic;
exports.Image = Image;
exports.LayoutFill = LayoutFill;
exports.LayoutThreeCol = LayoutThreeCol;
exports.ListDescription = ListDescription;
exports.ListOrdered = ListOrdered;
exports.ListUnordered = ListUnordered;
exports.Mark = Mark;
exports.Multiselect = Multiselect;
exports.Panel = Panel;
exports.Parenthesis = Parenthesis;
exports.Quote = Quote;
exports.Radio = Radio;
exports.Ruby = Ruby;
exports.Sample = Sample;
exports.Select = Select;
exports.Separator = Separator;
exports.Strikethrough = Strikethrough;
exports.Strong = Strong;
exports.Table = Table;
exports.UAnnotation = UAnnotation;
exports.Variable = Variable;
exports["default"] = Bluelib;
exports.useBluelib = useBluelib;
exports.useBluelibInBody = useBluelibInBody;
exports.useFormState = useFormState;
exports.usePromise = usePromise;
